// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#afis-app .app[data-v-2f7a1c36] {
  margin-bottom: 35px;
}
#afis-app .app-title[data-v-2f7a1c36] {
  color: #333;
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  margin: 13px 0px 20px 0px;
  font-family: "Avenir Next LT W01 Demi", Arial;
}
#afis-app a[data-v-2f7a1c36] {
  color: #1d5799;
}
#afis-app .shim-bottom-10[data-v-2f7a1c36] {
  margin-bottom: 10px;
}
#afis-app .shim-top-13[data-v-2f7a1c36] {
  margin-top: 13px;
}
#afis-app .detail-table[data-v-2f7a1c36] {
  border-collapse: collapse;
  color: #333;
  font-family: "AvenirNextLTW01-regular";
  font-size: 18px;
}
#afis-app .detail-table td[data-v-2f7a1c36]:not(.second-row) {
  padding-right: 35px;
}
@media (max-width: 768px) and (min-width: 481px) {
#afis-app .detail-table td[data-v-2f7a1c36]:not(.second-row) {
    padding-right: 120px;
}
}
#afis-app .detail-table .label-row[data-v-2f7a1c36] {
  color: #666;
  font-size: 12px;
}
#afis-app .detail-table .separate[data-v-2f7a1c36] {
  border-left: 1px solid #ccc;
  padding-left: 25px;
  padding-right: 0;
}
#afis-app .detail-table.second[data-v-2f7a1c36] {
  margin-top: 10px;
}
#afis-app .disclosure-link[data-v-2f7a1c36] {
  display: block;
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  font-weight: 700;
}
#afis-app .legend-item[data-v-2f7a1c36] {
  color: #666;
  font-size: 12px;
  margin: 10px 10px 8px 0px;
  display: inline-block;
}
#afis-app .sub-header[data-v-2f7a1c36] {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
#afis-app .sub-header.active[data-v-2f7a1c36] {
  color: #000;
}
#afis-app .sub-header sup[data-v-2f7a1c36] {
  display: inline-block;
  text-decoration: none;
}
#afis-app .sub-info[data-v-2f7a1c36] {
  font-size: 12px;
  font-family: "AvenirNextLTW01-Condens 721299", Arial;
  color: #666;
}
#afis-app .colored-square[data-v-2f7a1c36] {
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
}
#afis-app .colored-circle[data-v-2f7a1c36] {
  border-radius: 5px;
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
}
#afis-app .blue-bar[data-v-2f7a1c36] {
  background-color: #f2fafd;
  display: inline-block;
  height: 21px;
  padding-left: 10px;
  white-space: nowrap;
}
#afis-app .blue-row-fill[data-v-2f7a1c36] {
  background-color: #f2fafd;
}
#afis-app .blue-fill[data-v-2f7a1c36] {
  background-color: #009adf;
}
#afis-app .off-blue-fill[data-v-2f7a1c36] {
  background-color: #4B7BB3;
}
#afis-app .light-blue-fill[data-v-2f7a1c36] {
  background-color: #66C7F2;
}
#afis-app .pale-blue-fill[data-v-2f7a1c36] {
  background-color: #CCEBF9;
}
#afis-app .gray-fill[data-v-2f7a1c36] {
  background-color: #666;
}
#afis-app .medium-gray-fill[data-v-2f7a1c36] {
  background-color: #999;
}
#afis-app .light-gray-fill[data-v-2f7a1c36] {
  background-color: #ccc;
}
#afis-app .lighter-gray-fill[data-v-2f7a1c36] {
  background-color: #E4E4E4;
}
#afis-app .lightest-gray-fill[data-v-2f7a1c36] {
  background-color: #F5F5F5;
}
#afis-app .yellow-fill[data-v-2f7a1c36] {
  background-color: #F2B900;
}
#afis-app .light-yellow-fill[data-v-2f7a1c36] {
  background-color: #F7D566;
}
#afis-app .pale-yellow-fill[data-v-2f7a1c36] {
  background-color: #FCF1CC;
}
#afis-app .pale-yellow-fill[data-v-2f7a1c36] {
  background-color: #FCF1CC;
}
#afis-app .aqua-fill[data-v-2f7a1c36] {
  background-color: #37B8A9;
}
#afis-app .no-wrap[data-v-2f7a1c36] {
  white-space: nowrap;
}
#afis-app .trademark[data-v-2f7a1c36] {
  line-height: initial;
  vertical-align: super;
  font-size: 9px;
}
#afis-app .com-mod-utility-link[data-v-2f7a1c36] {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
  padding-right: 14px;
}
#afis-app .com-mod-utility-link i.utility[data-v-2f7a1c36] {
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  display: inline-block;
  height: 16px;
  width: 16px;
  margin-right: 5px;
  vertical-align: text-bottom;
}
#afis-app table[data-v-2f7a1c36] {
  margin-bottom: 20px;
  width: 100%;
}
#afis-app table .table-data[data-v-2f7a1c36] {
  color: #666;
  font-size: 14px;
  font-family: "AvenirNextLTW01-Regular", Arial;
  line-height: 18px;
}
#afis-app table .com-mod-table-label[data-v-2f7a1c36],
#afis-app table .com-mod-table-data[data-v-2f7a1c36] {
  color: #666;
  font-size: 14px;
  font-family: "AvenirNextLTW01-Regular", Arial;
  vertical-align: top;
  padding: 2px 8px 2px 8px;
}
#afis-app table .com-mod-table-label.strong[data-v-2f7a1c36],
#afis-app table .com-mod-table-data.strong[data-v-2f7a1c36] {
  position: relative;
  z-index: 10;
}
#afis-app table th[data-v-2f7a1c36] {
  font-weight: normal;
}
#afis-app table .sub-info[data-v-2f7a1c36] {
  padding: 2px 8px 2px 8px;
}
#afis-app table .align-right[data-v-2f7a1c36] {
  text-align: right;
}
#afis-app table .sub-table[data-v-2f7a1c36] {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/module.less","webpack://./RatingsAndRisk.vue","webpack://./src/assets/css/table.less"],"names":[],"mappings":"AAAA;EAEQ,mBAAA;ACAR;ADFA;EAKQ,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACN,6CAAA;ACAF;ADVA;EAaQ,cAAA;ACAR;ADbA;EAgBQ,mBAAA;ACAR;ADhBA;EAmBQ,gBAAA;ACAR;ADnBA;EAsBQ,yBAAA;EACA,WAAA;EACA,sCAAA;EACA,eAAA;ACAR;ADzBA;EA2BY,mBAAA;ACCZ;ADAY;AAAA;IACI,oBAAA;ACGd;AACF;ADjCA;EAiCY,WAAA;EACA,eAAA;ACGZ;ADrCA;EAqCY,2BAAA;EACA,kBAAA;EACA,gBAAA;ACGZ;ADDQ;EACI,gBAAA;ACGZ;AD7CA;EA8CQ,cAAA;EACH,yDAAA;EACG,gBAAA;ACER;ADlDA;EAmDK,WAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;ACEL;ADxDA;EAyDK,yDAAA;ACEL;ADDK;EACC,WAAA;ACGN;AD9DA;EA8DM,qBAAA;EACA,qBAAA;ACGN;ADlEA;EAmEE,eAAA;EACM,oDAAA;EACA,WAAA;ACER;ADvEA;EAwEK,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;ACEL;AD7EA;EA8EQ,kBAAA;EACH,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;ACEL;ADpFA;EA4FQ,yBAAA;EANA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ACER;AD3FA;EA4FQ,yBAAA;ACER;AD9FA;EA+FK,yBAAA;ACEL;ADjGA;EAkGK,yBAAA;ACEL;ADpGA;EAqGE,yBAAA;ACEF;ADvGA;EAwGE,yBAAA;ACEF;AD1GA;EA2GK,sBAAA;ACEL;AD7GA;EA8GE,sBAAA;ACEF;ADhHA;EAiHK,sBAAA;ACEL;ADnHA;EAoHK,yBAAA;ACEL;ADtHA;EAuHK,yBAAA;ACEL;ADzHA;EA0HE,yBAAA;ACEF;AD5HA;EA6HE,yBAAA;ACEF;AD/HA;EAgIE,yBAAA;ACEF;ADlIA;EAmIE,yBAAA;ACEF;ADrIA;EAsIE,yBAAA;ACEF;ADxIA;EAyIQ,mBAAA;ACER;AD3IA;EA4IQ,oBAAA;EACA,qBAAA;EACA,cAAA;ACER;ADhJA;EAiJQ,yDAAA;EACA,mBAAA;ACER;ADpJA;EAoJY,4BAAA;EACA,kCAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;ACGZ;AD9JA;EEOC,mBAAA;EACA,WAAA;AD0JD;ADlKA;EEUE,WAAA;EACA,eAAA;EACA,6CAAA;EACA,iBAAA;AD2JF;ADxKA;;EEiBE,WAAA;EACA,eAAA;EACA,6CAAA;EACA,mBAAA;EACA,wBAAA;AD2JF;AC1JE;;EACA,kBAAA;EACA,WAAA;AD6JF;ADrLA;EE6BE,mBAAA;AD2JF;ADxLA;EEgCE,wBAAA;AD2JF;AD3LA;EEmCE,iBAAA;AD2JF;AD9LA;EEsCE,kBAAA;AD2JF","sourcesContent":["#afis-app {\n    .app {\n        margin-bottom: 35px;\n    }\n    .app-title {\n        color: #333;\n        display: inline-block;\n        font-size: 18px;\n        font-weight: 500;\n        margin: 13px 0px 20px 0px;\n\t\tfont-family: \"Avenir Next LT W01 Demi\",Arial;\n\t}\n    a {\n        color: #1d5799\n    }\n    .shim-bottom-10 {\n        margin-bottom: 10px\n    }\n    .shim-top-13 {\n        margin-top: 13px;\n    }\n    .detail-table {\n        border-collapse: collapse;\n        color: #333;\n        font-family:\"AvenirNextLTW01-regular\";\n        font-size: 18px;\n        td:not(.second-row) {\n            padding-right: 35px;\n            @media (max-width: 768px) and (min-width: 481px) {\n                padding-right: 120px;\n            }\n        }\n        .label-row {\n            color: #666;\n            font-size: 12px;\n        }\n        .separate {\n            border-left: 1px solid #ccc;\n            padding-left: 25px;\n            padding-right: 0;\n        }\n        &.second {\n            margin-top: 10px;\n        }\n\t}\n    .disclosure-link {\n        display: block;\n    \tfont-family:\"Avenir Next LT W01 Demi\",Arial,sans-serif;\n        font-weight: 700;\n\t}\n    .legend-item {\n    \tcolor: #666;\n    \tfont-size: 12px;\n    \tmargin: 10px 10px 8px 0px;\n    \tdisplay: inline-block;\n    }\n    .sub-header {\n    \tfont-family:\"Avenir Next LT W01 Demi\", Arial, sans-serif;\n    \t&.active {\n    \t\tcolor: #000;\n    \t}\n    \tsup {\n    \t\tdisplay: inline-block;\n    \t\ttext-decoration: none;\n    \t}\n\t}\n\t.sub-info {\n\t\tfont-size: 12px;\n        font-family:\"AvenirNextLTW01-Condens 721299\", Arial;\n        color: #666;\n\t}\n    .colored-square {\n    \tdisplay:inline-block;\n    \theight: 10px;\n    \tmargin-right: 5px;\n    \twidth: 10px;\n    }\n    .colored-circle {\n        border-radius: 5px;\n    \tdisplay:inline-block;\n    \theight: 10px;\n    \tmargin-right:5px;\n    \twidth: 10px;\n    }\n    .blue-bar {\n        .blue-row-fill;\n        display:inline-block;\n        height: 21px;\n        padding-left: 10px;\n        white-space: nowrap;\n    }\n    .blue-row-fill {\n        background-color: #f2fafd;\n    }\n    .blue-fill {\n    \tbackground-color: #009adf;\n    }\n\t.off-blue-fill {\n    \tbackground-color: #4B7BB3;\n\t}\n\t.light-blue-fill {\n\t\tbackground-color: #66C7F2;\n\t}\n\t.pale-blue-fill {\n\t\tbackground-color: #CCEBF9;\n\t}\n   .gray-fill {\n    \tbackground-color: #666;\n    }\n\t.medium-gray-fill {\n\t\tbackground-color: #999;\n\t}\n    .light-gray-fill {\n    \tbackground-color: #ccc;\n    }\n    .lighter-gray-fill {\n    \tbackground-color: #E4E4E4;\n    }\n    .lightest-gray-fill {\n    \tbackground-color: #F5F5F5;\n    }\n\t.yellow-fill {\n\t\tbackground-color: #F2B900;\n\t}\n\t.light-yellow-fill {\n\t\tbackground-color: #F7D566;\n\t}\n\t.pale-yellow-fill {\n\t\tbackground-color: #FCF1CC;\n\t}\n\t.pale-yellow-fill {\n\t\tbackground-color: #FCF1CC;\n\t}\n\t.aqua-fill {\n\t\tbackground-color: #37B8A9;\n\t}\n    .no-wrap {\n        white-space: nowrap;\n    }\n    .trademark {\n        line-height: initial;\n        vertical-align: super;\n        font-size: 9px;\n    }\n    .com-mod-utility-link {\n        font-family: \"Avenir Next LT W01 Demi\",Arial,sans-serif;\n        padding-right: 14px;\n        i.utility {\n            background-repeat: no-repeat;\n            background-position: center center;\n            cursor: pointer;\n            display: inline-block;\n            height: 16px;\n            width: 16px;\n            margin-right: 5px;\n            vertical-align: text-bottom;\n        }\n    }\n\t@import './table.less';\n}\n","#afis-app .app {\n  margin-bottom: 35px;\n}\n#afis-app .app-title {\n  color: #333;\n  display: inline-block;\n  font-size: 18px;\n  font-weight: 500;\n  margin: 13px 0px 20px 0px;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n}\n#afis-app a {\n  color: #1d5799;\n}\n#afis-app .shim-bottom-10 {\n  margin-bottom: 10px;\n}\n#afis-app .shim-top-13 {\n  margin-top: 13px;\n}\n#afis-app .detail-table {\n  border-collapse: collapse;\n  color: #333;\n  font-family: \"AvenirNextLTW01-regular\";\n  font-size: 18px;\n}\n#afis-app .detail-table td:not(.second-row) {\n  padding-right: 35px;\n}\n@media (max-width: 768px) and (min-width: 481px) {\n  #afis-app .detail-table td:not(.second-row) {\n    padding-right: 120px;\n  }\n}\n#afis-app .detail-table .label-row {\n  color: #666;\n  font-size: 12px;\n}\n#afis-app .detail-table .separate {\n  border-left: 1px solid #ccc;\n  padding-left: 25px;\n  padding-right: 0;\n}\n#afis-app .detail-table.second {\n  margin-top: 10px;\n}\n#afis-app .disclosure-link {\n  display: block;\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  font-weight: 700;\n}\n#afis-app .legend-item {\n  color: #666;\n  font-size: 12px;\n  margin: 10px 10px 8px 0px;\n  display: inline-block;\n}\n#afis-app .sub-header {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n#afis-app .sub-header.active {\n  color: #000;\n}\n#afis-app .sub-header sup {\n  display: inline-block;\n  text-decoration: none;\n}\n#afis-app .sub-info {\n  font-size: 12px;\n  font-family: \"AvenirNextLTW01-Condens 721299\", Arial;\n  color: #666;\n}\n#afis-app .colored-square {\n  display: inline-block;\n  height: 10px;\n  margin-right: 5px;\n  width: 10px;\n}\n#afis-app .colored-circle {\n  border-radius: 5px;\n  display: inline-block;\n  height: 10px;\n  margin-right: 5px;\n  width: 10px;\n}\n#afis-app .blue-bar {\n  background-color: #f2fafd;\n  display: inline-block;\n  height: 21px;\n  padding-left: 10px;\n  white-space: nowrap;\n}\n#afis-app .blue-row-fill {\n  background-color: #f2fafd;\n}\n#afis-app .blue-fill {\n  background-color: #009adf;\n}\n#afis-app .off-blue-fill {\n  background-color: #4B7BB3;\n}\n#afis-app .light-blue-fill {\n  background-color: #66C7F2;\n}\n#afis-app .pale-blue-fill {\n  background-color: #CCEBF9;\n}\n#afis-app .gray-fill {\n  background-color: #666;\n}\n#afis-app .medium-gray-fill {\n  background-color: #999;\n}\n#afis-app .light-gray-fill {\n  background-color: #ccc;\n}\n#afis-app .lighter-gray-fill {\n  background-color: #E4E4E4;\n}\n#afis-app .lightest-gray-fill {\n  background-color: #F5F5F5;\n}\n#afis-app .yellow-fill {\n  background-color: #F2B900;\n}\n#afis-app .light-yellow-fill {\n  background-color: #F7D566;\n}\n#afis-app .pale-yellow-fill {\n  background-color: #FCF1CC;\n}\n#afis-app .pale-yellow-fill {\n  background-color: #FCF1CC;\n}\n#afis-app .aqua-fill {\n  background-color: #37B8A9;\n}\n#afis-app .no-wrap {\n  white-space: nowrap;\n}\n#afis-app .trademark {\n  line-height: initial;\n  vertical-align: super;\n  font-size: 9px;\n}\n#afis-app .com-mod-utility-link {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n  padding-right: 14px;\n}\n#afis-app .com-mod-utility-link i.utility {\n  background-repeat: no-repeat;\n  background-position: center center;\n  cursor: pointer;\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n  margin-right: 5px;\n  vertical-align: text-bottom;\n}\n#afis-app table {\n  margin-bottom: 20px;\n  width: 100%;\n}\n#afis-app table .table-data {\n  color: #666;\n  font-size: 14px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  line-height: 18px;\n}\n#afis-app table .com-mod-table-label,\n#afis-app table .com-mod-table-data {\n  color: #666;\n  font-size: 14px;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  vertical-align: top;\n  padding: 2px 8px 2px 8px;\n}\n#afis-app table .com-mod-table-label.strong,\n#afis-app table .com-mod-table-data.strong {\n  position: relative;\n  z-index: 10;\n}\n#afis-app table th {\n  font-weight: normal;\n}\n#afis-app table .sub-info {\n  padding: 2px 8px 2px 8px;\n}\n#afis-app table .align-right {\n  text-align: right;\n}\n#afis-app table .sub-table {\n  margin-bottom: 0px;\n}\n","\n@table-font-color:  #666;\n@table-font-size: 14px;\n@table-font-family: \"AvenirNextLTW01-Regular\",Arial;\n@table-line-height: 18px;\n\ntable {\n\tmargin-bottom: 20px;\n\twidth: 100%;\n\t.table-data {\n\t\tcolor: @table-font-color;\n\t\tfont-size: @table-font-size;\n\t\tfont-family: @table-font-family;\n\t\tline-height: @table-line-height;\n\t}\n\n\t.com-mod-table-label, .com-mod-table-data  {\n\t\tcolor: @table-font-color;\n\t\tfont-size: @table-font-size;\n\t\tfont-family:  @table-font-family;\n\t\tvertical-align: top;\n\t\tpadding: 2px 8px 2px 8px;\n\t\t&.strong {\n\t\tposition: relative;\n\t\tz-index: 10;\n\t\t}\n\t}\n\n\tth {\n\t\tfont-weight: normal;\n\t}\n\t.sub-info {\n\t\tpadding: 2px 8px 2px 8px;\n\t}\n\t.align-right {\n\t\ttext-align: right;\n\t}\n\t.sub-table {\n\t\tmargin-bottom: 0px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
